import { styled } from 'styled-components';

import { DeviceQueries } from 'Common/components/styled';

export const Cell = styled.div<{ $alignRight?: boolean, $highlight?: boolean }>`
  padding: 12px 16px;
  border-bottom: 1px solid #E4E7EF;
  display: flex;
  align-items: center;
  min-height: 44px;
  ${({ $alignRight }) => $alignRight ? 'justify-content: right;' : ''}
  font-size: 13px;
  color: #1A1D2B;
  transition: background-color 0.15s ease;
  ${({$highlight}) => $highlight ? 'background: #fcc;' : ''}
`;

export const DesktopRow = styled.div`
  display: contents;
  cursor: pointer;

  &:hover ${Cell} {
    background: #F0F1F6;
  }

  &:hover ${Cell}:last-child::after {
    content: '→';
    margin-left: auto;
    padding-left: 8px;
    color: #8890A5;
    font-size: 14px;
  }

  @media (${DeviceQueries.mobile}) {
    display: none;
  }
`;


export const MobileCard = styled.div`
  display: none;
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #E4E7EF;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (${DeviceQueries.mobile}) {
    display: block;
  }
`;

export const CardHeader = styled.div`
  padding: 16px;
  background: linear-gradient(to bottom, #FAFAFC, #ffffff);
  border-bottom: 1px solid #E4E7EF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const CardBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const CardLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #5A6178;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CardValue = styled.div<{$highlight?: boolean}>`
  font-size: 14px;
  color: #1A1D2B;
  text-align: right;
  ${({$highlight}) => $highlight ? 'background: #fcc;' : ''}
`;

export const ProductTitle = styled.div`
  font-weight: 500;
  color: #1A1D2B;
`;

export const UserId = styled.code`
  background: #F0F1F6;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
  font-family: 'SF Mono', 'Monaco', 'Courier New', monospace;
  color: #5A6178;
`;

export const StatusBadge = styled.div<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  background-color: ${props => props.$color};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;
